<!-- OrganizationID -->

<div class="support-tool">
    <div class="support-tool-title">Aggregate License Report</div>
    <div class="support-tool-content">
        <div class="support-tool-input-box">
            <span class="support-tool-input-label">OrganizationID</span>
            <input type="number" class="support-tool-input" [(ngModel)]="organizationID">
        </div>

        <div class="support-tool-input-box">
            <span class="support-tool-input-label">StartDate</span>
            <app-datepicker [(model)]="startDate"></app-datepicker>
        </div>

        <div class="support-tool-input-box">
            <span class="support-tool-input-label">EndDate</span>
            <app-datepicker [(model)]="endDate"></app-datepicker>
        </div>

        <button *ngIf="!running" class="btn btn-primary support-tool-button" (click)="getResult()">Run</button>
        
        <app-loading-spinner *ngIf="running"></app-loading-spinner>
    </div>
</div>